module.exports = __webpack_public_path__ + "static/img/base_naval.f3ffabf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/base_naval.jpg
// module id = 5tcQ
// module chunks = 0